import React, { type FC } from 'react';
import { type Layout } from '../../types';
import { ExpandableList } from './components/ExpandableList';
import { Fieldset } from './components/Fieldset';

interface Props {
  layout: Layout;
  isExpanded?: boolean;
  onExpand(): void;
}

export const PaymentMethodsListView: FC<Props> = (props) => {
  const { layout, isExpanded, onExpand } = props;

  if (layout === 'horizontal') {
    return <Fieldset />;
  }

  if (layout === 'vertical') {
    return <ExpandableList isExpanded={isExpanded} onExpand={onExpand} />;
  }

  return null;
};
